const TOKEN_KEY = 'access-token';

/**
 * 获取token
 */
export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (error) {
    console.error('Failed to get token from localStorage:', error);
    return null;
  }
}

/**
 * 设置token
 */
export function setToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch (error) {
    console.error('Failed to set token to localStorage:', error);
  }
}

/**
 * 清除token
 */
export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (error) {
    console.error('Failed to clear token from localStorage:', error);
  }
}

/**
 * 检查是否有token
 */
export function hasToken(): boolean {
  return getToken() !== null;
}
